import { useResetUnmarkedItemsInventory } from '@/core/domain/inventory/inventories/inventory.hooks';
import {
  Inventory,
  InventoryStatus,
} from '@/core/domain/inventory/inventories/Inventory.types';

import { Button, Modal } from 'antd';

interface Props {
  disabled: boolean;
  inventory: Inventory;
}

const ResetUnmarkedItemsInventoryModal = ({ disabled, inventory }: Props) => {
  const resetUnmarkedItemsInventory = useResetUnmarkedItemsInventory();

  const handleSave = () => {
    Modal.confirm({
      title: 'Zerar itens não marcados',
      content: (
        <p>
          <strong>
            Deseja realmente zerar todos os itens não marcados deste inventário?
          </strong>
          <br />
          Essa ação irá marcá-los como concluídos e definir suas quantidades
          como zero
        </p>
      ),
      onOk: async () =>
        await resetUnmarkedItemsInventory.mutateAsync(inventory.id),
      okText: 'Confirmar',
    });
  };

  return (
    <Button
      type="primary"
      onClick={handleSave}
      disabled={
        disabled ||
        inventory?.status === InventoryStatus.DONE ||
        inventory?.status === InventoryStatus.PROCESSING ||
        inventory?.status === InventoryStatus.IMPORTING
      }
    >
      Zerar itens não marcados
    </Button>
  );
};

export default ResetUnmarkedItemsInventoryModal;
